import React, {Component} from 'react';
import styles from './styles.css';

export default class SmartyTextarea extends Component {
	componentDidMount() {
		var then = this;
		let {onChange, ...props} = this.props;
		var wysiwyg = $(this.wysiwyg);

		var cm = CodeMirror.fromTextArea(this.wysiwyg,
			{
				mode: 'smartymixed',
				tabSize: 4,
				indentUnit: 4,
				indentWithTabs: true,
				height: "dynamic",
				viewportMargin: 2,
				lineWrapping: true,
				onChange: function (cm) {
					var e = $.Event('change', {target: then.wysiwyg});
					then.selfChange = true;
					then.wysiwyg.value = cm.getValue();

					if (onChange)
					{
						onChange(e);
					}
				}
			});

		wysiwyg.on('refresh', function () {
			cm.refresh();
		});

		setTimeout(function () {
			wysiwyg.trigger('refresh');
		}, 0);
	}

	render() {
		let className = styles['bsui-smarty-textarea'];
		const {extend, ...props} = this.props;

		if (extend)
		{
			className += ' ' + styles['bsui-smarty-textarea_big'];
		}

		return (
			<div className={className}>
				<textarea className={styles['bsui-smarty-textarea__control']} {...props}
					ref={(input) => this.wysiwyg = input}/>
			</div>
		);
	}
}